import { useState } from 'react';

export const useDiagram = () => {
  const [state, setState] = useState<'' | 'rendering' | 'ready'>('');

  return { state, setState };
};
